import React, { useEffect, useState } from "react";
import PayoutMethod from "./PayoutMethod";
import PaymentHistory from "./PaymentHistory";
import PayoutHistory from "./PayoutHistory";
import PaymentHeader from "./PaymentHeader";
import InsideHeader from "../../components/InsideHeader";
import { useDispatch, useSelector } from "react-redux";
import { fetchNdovupayWallet, fetchOrganization, fetchTariffs } from "../../features/dropdown/dropdownSlice";
import NoDataTable from "../../components/NoDataTable";
import CardLoading from "../../components/CardLoading";
import CreateNdovuWalletModal from "./modal/CreateNdovuWalletModal";

function PaymentList() {
  const { ndovuWallet, loading } = useSelector((state) => state.dropdown);
  const dispatch = useDispatch();
  async function fetchNdovupayWalletData() {
    await dispatch(fetchNdovupayWallet());
  }

  const [open, setopen] = useState(false)

  function handleCancel() {
    setopen(false);
  }


  const collectionWallet =
    ndovuWallet && ndovuWallet?.find((item) => item?.walType === "DISBURSEMENT");
 

  async function fetchOrganizationData() {
    await dispatch(fetchOrganization());
  }

  async function fetchTariffsData(){
    await dispatch(fetchTariffs())
  }

  useEffect(() => {
    fetchNdovupayWalletData();
    fetchOrganizationData()
    fetchTariffsData()
  }, []);

  const handleAdd = () => {
    setopen(true)
  };
 
  if (loading) return <CardLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Summary Transactions"
        subtitle="View of all your finances Summary Transactions"
        back={false}
        
      />
      <div className="lg:px-10 px-3 bg-white rounded-[10px] pt-[1.25rem]">
        {ndovuWallet && ndovuWallet?.length > 0 ? (
          <>
            <PaymentHeader collectionWallet={collectionWallet}/>
            <div className="flex lg:flex-row flex-col lg:gap-x-[1rem] gap-y-[1rem] mt-8">
              <PayoutMethod />
              <PaymentHistory />
            </div>
            <PayoutHistory />
          </>
        ) : (
          <>
            <NoDataTable
              title="Let’s start by creating ndovupay wallet"
              imgTitle="Create ndovupay wallet to start transacting"
              btnTile="Create Wallet"
              handleAddFolder={handleAdd}
            />
          </>
        )}
      </div>

      <CreateNdovuWalletModal
        handleFetchData={fetchNdovupayWalletData}
        open={open}
        handleCancel={handleCancel} 
      />
 

    </div>
  );
}

export default PaymentList;
